import { formTypeFactory } from "apps/visits/packages/shared/modules/synerise";
import * as yup from "yup";
import { type ContactAgreementValues, contactAgreementValues } from "../constants";

export const vouchersDistributionCheckoutForm = formTypeFactory(
  "vouchers_distribution_checkout_form",
  yup.object({
    email: yup.string().email().required(),
    phone: yup.string().required(),
    firstname: yup.string().min(3).required(),
    lastname: yup.string().min(3).required(),
    newsletterAgreement: yup
      .mixed<ContactAgreementValues>()
      .oneOf([...contactAgreementValues])
      .required(),
    phoneContactAgreement: yup
      .mixed<ContactAgreementValues>()
      .oneOf([...contactAgreementValues])
      .optional(),
  }),
);
